export default {
  budgets: 'Presupuestos {from}%–{to}%',
  reference: 'Referencia {value} {unit}',
  ready: 'Lista',
  running: 'Calculando simulación...',
  createdBy: 'Creada por',
  on: 'el',
  clone: 'Clonar',
  edit: 'Editar',
  editWhenDone: 'Se puede editar cuando todos los presupuestos estén calculados',
  settings: 'Configuración',
  showToExternalUsers: 'Mostrar a usuarios externos',
  save: 'Guardar',
  printJsonToConsole: 'Imprimir JSON en la consola',
  viewMore: 'Ver más',
  viewMoreWhenDone: 'Disponible cuando todos los presupuestos estén calculados'
}
